import { createFileRoute, notFound } from "@tanstack/react-router";
import { ActivityRouteView } from "@/components/activity/activity-route-view";
import { homeViewFromParam } from "@/components/activity/home-stream-model";
import { useWorkspaceRoot } from "@/lib/api";
import { pruneSearch } from "@/lib/router-search";

/**
 * Home's named views are paths, not query params: `/views/activity`,
 * `/views/sessions`, `/views/feeds`, `/views/automations`. The default Needs
 * attention view stays at the bare workspace root, so the first tab has a
 * stable address and `/views/attention` remains a valid explicit alias.
 */
export const Route = createFileRoute("/$owner/views/$view")({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
	},
	validateSearch: (search: Record<string, unknown>) =>
		pruneSearch(search) as Record<string, string | undefined>,
	component: HomeViewPage,
});

function HomeViewPage() {
	const { owner, view } = Route.useParams();
	const search = Route.useSearch();
	const homeView = homeViewFromParam(view);
	if (!homeView) throw notFound();
	return (
		<ActivityRouteView owner={owner} search={search} homeView={homeView} />
	);
}
